export default __webpack_public_path__ + "static/wallpaper-7-pc-15058261fc6d58774d8f05538d2c7599.png";